import { Component, OnInit, PLATFORM_ID, Inject, ElementRef, viewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
	selector: 'app-listing-page-footer',
	standalone: true,
	providers: [],
	imports: [CommonModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	templateUrl: './listing-page-footer.component.html',
	styleUrls: ['./listing-page-footer.component.css']
})
export class ListingPageFooter implements OnInit {
	isBrowser: boolean;
	testimonialSwiper = viewChild<ElementRef>('testimonialSwiper');

	partnersList = [
		{
			"id": 6,
			"name": "Amigo Tours",
			"logo": "092026/1789046729_1771565687-brand-logo07-1-6aa2afbb8b4a3.png",
			"about": "Amigo Tours",
			"status": 1,
			"created_at": "2026-02-20T10:34:47.000Z",
			"updated_at": "2026-09-10T13:25:29.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789046729_1771565687-brand-logo07-1-6aa2afbb8b4a3.png"
		},
		{
			"id": 7,
			"name": "Big Bus",
			"logo": "092026/1789046357_1771565720_brand-logo01.png",
			"about": "Big Bus",
			"status": 1,
			"created_at": "2026-02-20T10:35:20.000Z",
			"updated_at": "2026-09-10T13:19:17.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789046357_1771565720_brand-logo01.png"
		},
		{
			"id": 8,
			"name": "City Wonders",
			"logo": "092026/1789046299_1771565753_brand-logo02.png",
			"about": "City Wonders",
			"status": 1,
			"created_at": "2026-02-20T10:35:53.000Z",
			"updated_at": "2026-09-10T13:18:19.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789046299_1771565753_brand-logo02.png"
		},
		{
			"id": 9,
			"name": "Intrepid Urban Adventurs",
			"logo": "092026/1789046276_1771565811_brand-logo03.png",
			"about": "Intrepid Urban Adventurs",
			"status": 1,
			"created_at": "2026-02-20T10:36:51.000Z",
			"updated_at": "2026-09-10T13:17:56.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789046276_1771565811_brand-logo03.png"
		},
		{
			"id": 10,
			"name": "Secret Food Tours",
			"logo": "092026/1789046182_1771565883_brand-logo04.png",
			"about": "Secret Food Tours",
			"status": 1,
			"created_at": "2026-02-20T10:38:03.000Z",
			"updated_at": "2026-09-10T13:16:22.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789046182_1771565883_brand-logo04.png"
		},
		{
			"id": 11,
			"name": "Go City",
			"logo": "092026/1789045954_1771565905_brand-logo05.png",
			"about": "Go City",
			"status": 1,
			"created_at": "2026-02-20T10:38:25.000Z",
			"updated_at": "2026-09-10T13:12:34.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789045954_1771565905_brand-logo05.png"
		},
		{
			"id": 12,
			"name": "Gray Line",
			"logo": "092026/1789046121_1771565929_brand-logo06.png",
			"about": "Gray Line",
			"status": 1,
			"created_at": "2026-02-20T10:38:49.000Z",
			"updated_at": "2026-09-10T13:15:21.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789046121_1771565929_brand-logo06.png"
		},
		{
			"id": 13,
			"name": "Fareharbor",
			"logo": "092026/1789046088_1771566059_FareHarbor_BlueTicket_CutOut.png",
			"about": "Fareharbor",
			"status": 1,
			"created_at": "2026-02-20T10:40:59.000Z",
			"updated_at": "2026-09-10T13:14:48.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789046088_1771566059_FareHarbor_BlueTicket_CutOut.png"
		},
		{
			"id": 14,
			"name": "LinkTwist",
			"logo": "092026/1789046025_1771566364_logoSmallYellowBlack.png",
			"about": "LinkTwist",
			"status": 1,
			"created_at": "2026-02-20T10:46:04.000Z",
			"updated_at": "2026-09-10T13:13:45.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/spur_partners/092026/1789046025_1771566364_logoSmallYellowBlack.png"
		}
	]

	sectionData = [
		{
			"id": 280,
			"section_id": 128,
			"title": "Loved Whale Watching!",
			"description": "What an amazing tour. We saw whales, dolphins and porpoises. The crew was very friendly and enthusiastic. We could really tell they are very respectful towards the animals, we were able to see two humpbacks for nearly half an hour, everybody was silent, the engine was off and the crew was also in awe. Only when the whales left, the engine was back on and we also started moving again. We really felt like we had all the time in the world and we didn't disturb the animals. - Saskia",
			"image": "092026/1789102636_foodies(1).png",
			"video": null,
			"class_position": "3",
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T05:31:21.000Z",
			"updated_at": "2026-09-11T04:57:18.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102636_foodies(1).png",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102636_foodies(1).png"
		},
		{
			"id": 281,
			"section_id": 128,
			"title": "We Ziplined in Iceland!  Epic Tour!",
			"description": "We had an amazing time flying over the beautiful canyons, admiring the waterfalls from above. While we are both quite adventurous, I have an occasional fear of heights. The staff was incredibly friendly and professional, putting our minds perfectly at ease and making the best experience for us possible. - Campden",
			"image": "092026/1789102638_about_us_menu.png",
			"video": null,
			"class_position": "5",
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T05:31:21.000Z",
			"updated_at": "2026-09-11T04:57:18.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102638_about_us_menu.png",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102638_about_us_menu.png"
		},
		{
			"id": 282,
			"section_id": 128,
			"title": "AWESOME!  Manta Rays in Hawaii is a Must!",
			"description": "This was one of the BEST experiences I have ever had!  We extended our trip into a two-tank dive and got to explore the surrounding areas of the garden eel bay before going into our manta show. - Kera",
			"image": "092026/1789102638_img_3.jpg",
			"video": null,
			"class_position": "4",
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T05:31:21.000Z",
			"updated_at": "2026-09-11T04:57:19.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102638_img_3.jpg",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102638_img_3.jpg"
		},
		{
			"id": 304,
			"section_id": 128,
			"title": "Amazing Food in Amazing Neighborhood!",
			"description": "This was one of our favorite experiences on the trip. Kensington Market is an incredible neighborhood with a vibrant culture. We had a LOT of food on this tour. If you're thinking this will be sample size HAHA you're wrong.\r\n- Alex and Benjamin",
			"image": "092026/1789102639_img_2.jpg",
			"video": null,
			"class_position": "1",
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T16:05:47.000Z",
			"updated_at": "2026-09-11T04:57:19.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102639_img_2.jpg",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102639_img_2.jpg"
		},
		{
			"id": 305,
			"section_id": 128,
			"title": "What an AMAZING experience!!!",
			"description": "We loved the small town atmosphere of this winery, and just how welcoming the staff and environment was. Definitely recommend doing this to anyone in the area!!\r\n- Kayla and Andrew",
			"image": "092026/1789102639_img_1.png",
			"video": null,
			"class_position": "2",
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T16:13:29.000Z",
			"updated_at": "2026-09-11T04:57:20.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102639_img_1.png",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102639_img_1.png"
		},
		{
			"id": 306,
			"section_id": 128,
			"title": "A Great Day!",
			"description": "Thank you Spur Experiences and Jessica for a great day in the Cinque Terre! The day included colorful towns, sea breeze, hiking, dipping my toes in the Mediterranean, history & local cuisine lessons, delicious food and gelato, and wonderful views.\r\n- Bonnie",
			"image": "092026/1789102640_registry_img02.jpg",
			"video": null,
			"class_position": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T16:21:29.000Z",
			"updated_at": "2026-09-11T04:57:20.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102640_registry_img02.jpg",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102640_registry_img02.jpg"
		},
		{
			"id": 307,
			"section_id": 128,
			"title": "Fun Snorkeling Experience in Parguera",
			"description": "A wedding guest bought this voucher for me and my husband from our wedding registry via The Knot. We had Chiqui and Jonathan as our guides and they were great! Very personable and knowledgeable. They provided a cooler with water, soda and beer. - Kathleen",
			"image": "092026/1789102640_gift_card.jpg",
			"video": null,
			"class_position": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T16:46:31.000Z",
			"updated_at": "2026-09-11T04:57:20.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102640_gift_card.jpg",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102640_gift_card.jpg"
		},
		{
			"id": 308,
			"section_id": 128,
			"title": "Hope to Come Back Someday!",
			"description": "The catamaran was smooth and clean. The food was wonderful. The captain and staff were friendly and engaging. We could have have asked for a more fun and educational experience around the island. The snorkeling was wonderful with tons of fish, corral and eels. - Whit",
			"image": "092026/1789102992_1789102640_gift_card.jpg",
			"video": null,
			"class_position": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T16:51:08.000Z",
			"updated_at": "2026-09-11T05:03:12.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102992_1789102640_gift_card.jpg",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/092026/1789102992_1789102640_gift_card.jpg"
		},
		{
			"id": 309,
			"section_id": 128,
			"title": "DO IT!!!!",
			"description": "My husband and I went on the catamaran cruise during our honeymoon in Milos... exceptional experience! I can not recommend it enough! Beautiful views, crystal clear water, delicious food and awesome crew! A trip to Milos would not be complete without this cruise! 10/10! - Ellen",
			"image": "012024/1704819239_review2.jpg",
			"video": null,
			"class_position": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T16:53:59.000Z",
			"updated_at": "2024-01-09T16:53:59.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/012024/1704819239_review2.jpg",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/012024/1704819239_review2.jpg"
		},
		{
			"id": 310,
			"section_id": 128,
			"title": "Fantastic Tour in Venice!",
			"description": "Francesca, our guide, was super personable and knowledgeable about the city and legends of Venice. The tour started near the train station and followed through all the alleys and streets to San Marco Square. The weather and the sunset were absolutely beautiful as well. - Courtney",
			"image": "012024/1704819470_review3.jpg",
			"video": null,
			"class_position": null,
			"status": 1,
			"is_deleted": 0,
			"created_at": "2024-01-09T16:57:50.000Z",
			"updated_at": "2024-01-09T16:58:53.000Z",
			"image_url": "https://spur-uat.b-cdn.net/public/uploads/page_sections/012024/1704819470_review3.jpg",
			"image_url2": "https://spur-uat.b-cdn.net/public/uploads/page_sections/012024/1704819470_review3.jpg"
		}
	]

	constructor(
		@Inject(PLATFORM_ID) platformId: Object) {
		this.isBrowser = isPlatformBrowser(platformId);
	}

	ngOnInit() {
	}

	trackByTestimonial = (_: number, record: any) =>
		record?.id ?? record?.title ?? _;

	private getSwiper(): any {
		if (!this.isBrowser) {
			return null;
		}
		return this.testimonialSwiper()?.nativeElement?.swiper ?? null;
	}

	slideNext() {
		this.getSwiper()?.slideNext();
	}

	slidePrev() {
		this.getSwiper()?.slidePrev();
	}

	pauseSwiper() {
		this.getSwiper()?.autoplay?.stop();
	}

	resumeSwiper() {
		this.getSwiper()?.autoplay?.start();
	}

	/** Pull reviewer name from trailing "- Name" in description when present. */
	getReviewerName(record: any): string {
		const description = (record?.description || '').toString().trim();
		const match = description.match(/[-–—]\s*([^-–—\n\r]+)\s*$/);
		if (match?.[1]) {
			return match[1].trim();
		}
		return record?.title || 'Guest';
	}

	getReviewText(record: any): string {
		const description = (record?.description || '').toString().trim();
		return description.replace(/\s*[-–—]\s*[^-–—\n\r]+\s*$/, '').trim();
	}

	getTimeAgo(dateString: string): string {
		if (!dateString) {
			return '';
		}

		const now = new Date().getTime();
		const past = new Date(dateString).getTime();
		const seconds = Math.floor((now - past) / 1000);

		const intervals: any = {
			year: 31536000,
			month: 2592000,
			day: 86400,
			hour: 3600,
			minute: 60
		};

		for (const key in intervals) {
			const value = Math.floor(seconds / intervals[key]);
			if (value >= 1) {
				return value + ' ' + key + (value > 1 ? 's' : '') + ' ago';
			}
		}

		return 'Just now';
	}
}
